const BaseURL = "https://flexibees.appinessworld.com/api/admin";
const SocketURL = "ws://flexibees.appinessworld.com/ws";
export const API = {
  //
  LOGIN: `${BaseURL}/login/`,
  CHANGE_PASSWORD: `${BaseURL}/change-password/`,
  FORGOT_PASSWORD: `${BaseURL}/forgot-password/`,
  MEDIA_UPLOAD: `${BaseURL}/media-upload/`,
  VIEW_PROFILE: `${BaseURL}/view-profile/`,
  EDIT_PROFILE: `${BaseURL}/edit-profile/`,
  GET_NOTIFICATION: `${BaseURL}/notification`,
  NOTIFICATION_COUNT: `${SocketURL}/admin-notification`,
  GET_RECRUITMENT: `${BaseURL}/recruitment`,
  GET_CLOSED: `${BaseURL}/closed`,
  UPDATE_LAUNCH_DATE: `${BaseURL}/update-launch-date`,
  VIEW_REOPEN_REASON: `${BaseURL}/view-reopen-reason`,
  VIEW_PROJECT_INFO: `${BaseURL}/project-info`,
  START_RECRUITMENT: `${BaseURL}/start-recruitment`,
  VIEW_PROJECT: `${BaseURL}/view-project`,
  UPDATE_ASSIGNMENT: `${BaseURL}/assignment-upload`,
  GET_WORKFLOW_ALL_CANDIDATE: `${BaseURL}/all-candidates`,
  GET_WORKFLOW_CANDIDATES_FILTERS: `${BaseURL}/project-all-candidates-filters`,
  ADD_TO_SHORTLIST: `${BaseURL}/add-to-shortlist/`,
  GET_WORKFLOW_SHORTLIST: `${BaseURL}/all-shortlist-candidates`,
  SEND_SHORTLIST_NOTIFICATION: `${BaseURL}/notify-shortlist-candidates/`,

  GET_CANDIDATES: `${BaseURL}/all-candidates-list`,
  GET_CANDIDATES_FILTERS: `${BaseURL}/all-candidates-filters/`,
  GET_CANDIDATE_DETAILS: `${BaseURL}/candidate-detail`,

  GET_WORKFLOW_INTEREST_CHECK: `${BaseURL}/interest-check-and-self-evaluation`,
  SKIP_ASSIGNMENT: `${BaseURL}/skip-assignment`,
  GET_SUSPENDED: `${BaseURL}/suspended`,
  GET_WORKFLOW_ASSIGNMENT: `${BaseURL}/assignment-candidates`,
  SEND_ASSIGNMENT: `${BaseURL}/send-assignment`,
  VIEW_FUNCTIONAL_FEEDBACK: `${BaseURL}/view-functional-feedback`,
  UPDATE_ASSIGNMENT_FEEDBACK: `${BaseURL}/update-assignment-feedback`,
  VIEW_ASSIGNMENT_FEEDBACK: `${BaseURL}/view-assignment-feedback`,
  MOVE_TO_NEXT_LEVEL: `${BaseURL}/next-level/`,
  GET_WORKFLOW_FUNCTIONAL: `${BaseURL}/functional-candidates`,
  VIEW_SELF_ASSESMENT: `${BaseURL}/self-assessment`,
  SCHEDULE_FLEXIFIT_INTERVIEW: `${BaseURL}/schedule-flexifit-interview`,
  SCHEDULE_FUNCTIONAL_INTERVIEW: `${BaseURL}/schedule-functional-interview`,
  GET_WORKFLOW_FLEXIFIT: `${BaseURL}/flexifit-candidates`,
  UPDATE_FUNCTIONAL_FEEDBACK: `${BaseURL}/update-functional-feedback`,
  VIEW_FLEXIFIT_FEEDBACK: `${BaseURL}/view-flexifit-feedback`,
  UPDATE_FLEXIFIT_FEEDBACK: `${BaseURL}/update-flexifit-feedback`,
  VIEW_CLIENT_FEEDBACK: `${BaseURL}/view-client-feedback`,
  SEND_TO_FINAL_SELECTION: `${BaseURL}/send-to-final`,

  GET_WORKFLOW_FINAL: `${BaseURL}/final-candidates`,

  SEND_SUSPEND_NOTIFICATION: `${BaseURL}/suspend-notify`,
  SEND_TO_BD_MANAGER: `${BaseURL}/send-to-bd`,

  SEND_FINAL_NOTIFICATION: `${BaseURL}/send-final-selection-notification`,
  GET_CANDIDATES_CITY_LIST: `${BaseURL}/all-candidates-city-list`,

  GET_ADMIN_ROLES: `${BaseURL}/role/`,
  GET_DYNAMIC_DROPDOWN_FROM_CONFIG: `${BaseURL}/dropdown-values/`,
  FROM_CRM: `${BaseURL}/from-crm`,
  GET_PROJECT_DETAILS: `${BaseURL}/project`,
  UPDATE_PROJECT: `${BaseURL}/recruiter-project-update`,
  GET_ADMIN_SKILLS: `${BaseURL}/skill/`,
  GET_ADMIN_DOMAINS: `${BaseURL}/domain/`,
  GET_LANGUAGES: `${BaseURL}/language/`,

  GET_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline`,
  DOWNLOAD_CANDIDATE_TIMELINE: `${BaseURL}/candidate-timeline-download`,
  DOWNLOAD_FLEXIBEES_RESUME: `${BaseURL}/candidate-resume-download`,
  CANDIDATE_JOURNEY: `${BaseURL}/candidate-journey`,
  CANDIDATE_JOURNEY_FEEDBACK: `${BaseURL}/candidate-feedback-list`,
  CANDIDATE_DETAILS_UPDATE:`${BaseURL}/candidate-details-update/`,

  // project launch apis
  PROJECT_LAUNCH_LIST:`${BaseURL}/project/launch/list`,
  EDIT_PROJECT_NOTES:`${BaseURL}/project/launch/update`,
  PROJECT_DETAILS_DOWNLOAD:`${BaseURL}/project/launch/download`,
  MARKETPLACE_UPDATE:`${BaseURL}/candidate-detail-mp-update`,

  MP_LAUNCH_LIST:`${BaseURL}/job/launch/list`,
  MP_LAUNCH_LIST_UPDATE:`${BaseURL}/job/launch/update`,
  MP_LAUNCH_LIST_EXPORT:`${BaseURL}/job/launch/download`,

  CREATE_PROJECT_LAUNCH:`${BaseURL}/launch-project/`,
  UPDATE_PROJECT_LAUNCH:`${BaseURL}/update-project-launch`,

  MP_LAUNCH_NOTE_LIST:`${BaseURL}/job/launch/notes-list`,
  MP_LAUNCH_CREATE_NOTE:`${BaseURL}/job/launch/create-notes`,

  MP_OFFERS_LIST:`${BaseURL}/offer/list`,
  MP_OFFER_CREATE:`${BaseURL}/add-offer-launch`,
  MP_OFFER_UPDATE:`${BaseURL}/edit-offer-launch`
};
